import {Structures} from 'octopus-model';

export const authentication = {
    displayLoginLogo: true,
    enableSSO: false,
    floatLabelControl: 'always', // 'always' | 'never' | 'auto'
    firstConnexionRedirection: {
        default: '/',
    },
    activeChangePasswordStrategy: false,
    onlyLoginWithMail: false,
    activateAuthenticationByThirdParty: true,// mettre true quand tout ok
    googleClientId: '1080262564187-sd06t50mcftmkf44gume7fvj67qucsjo.apps.googleusercontent.com',
    facebookAppId: '2648219812199516',
    appleRedirectUri: '/auth/apple/callback',
    appleClientId: 'com.sapiensforkids.app',
};